// extracted by mini-css-extract-plugin
module.exports = {"root":"ScanPlaceholder_root__30jY6","line":"ScanPlaceholder_line__1wXfy","mover":"ScanPlaceholder_mover__135C3","container":"ScanPlaceholder_container__2pBNG"};